import { useContext } from 'react';
import { ExportContext, ExportContextType } from '@/contexts/exportContext';

export default function useExport(): ExportContextType {
  return useContext(ExportContext);
}
